import { Reducer } from 'react';
import { ReportingViewState, ReportsConfig } from 'store/analytics/ui/analyticsUiTypes';
import {
  ReportingViewActionTypes,
  SELECT_MOCK_SERVICES,
  SELECT_REPORT,
  SET_DATE_RANGE,
  SET_FIXED_TIME_RANGE,
  SET_MS_SEARCH_KEYWORD,
  SET_REPORT_CONFIG,
  SET_RESOLUTION,
} from 'store/analytics/ui/subViews/reportingView/reportingViewActionTypes';
import { analyticsReportTypes, REPORT_TRANSACTION_DAILY_COUNTS } from 'store/analytics/analyticsReportTypes';
import { DateRange } from 'views/Analytics/AnalyticsMockService/Reporting/Pickers/BzmDateRangePicker/BzmDateRangePicker';
import _ from 'lodash';
import { ReportsData, ReportsDataState } from 'store/analytics/data/analyticsDataTypes';
import { MetricResolution } from 'types/rest/analyticsTypes';

export const initialDateRange: DateRange = { from: new Date(), to: new Date() };

export const reportingViewInitialState: ReportingViewState = {
  selectedReport: REPORT_TRANSACTION_DAILY_COUNTS,
  dateRange: { from: new Date(new Date().setDate(new Date().getDate() - 7)), to: new Date() },
  fixedTimeRange: 'DAY_7',
  resolution: '1D',
  searchKeyword: undefined,
  selectedMockServices: [],
} as ReportingViewState;

const initialConfigs: ReportingViewState[] = [];
analyticsReportTypes.forEach(rep => {
  initialConfigs.push({
    selectedReport: rep,
    dateRange: initialDateRange,
    fixedTimeRange: null,
    resolution: null,
    searchKeyword: undefined,
    selectedMockServices: [],
  } as ReportingViewState);
});
export const reportConfigInitialState = {
  configList: initialConfigs,
};

const reportsData: ReportsData[] = [];
analyticsReportTypes.forEach(rep => {
  reportsData.push({
    lastReloadTs: null,
    selectedReport: rep,
    reportType: rep.id,
    isLoading: false,
    rawData: {
      resolution: '',
      metrics: [],
    },
  } as ReportsData);
});

export const reportsDataInitialState: ReportsDataState = {
  isLoadingData: false,
  initialFetch: false,
  reportsData: reportsData,
};

type DateResolutionPairType = {
  id: string;
  value: MetricResolution;
};

export const reportingViewReducer: Reducer<ReportingViewState, ReportingViewActionTypes> = (
  state = reportingViewInitialState,
  action,
): ReportingViewState => {
  switch (action.type) {
    case SELECT_REPORT:
      return { ...state, selectedReport: action.payload };
    case SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };
    case SET_RESOLUTION:
      return { ...state, resolution: action.payload };
    case SET_FIXED_TIME_RANGE:
      return { ...state, fixedTimeRange: action.payload };
    case SET_MS_SEARCH_KEYWORD:
      return { ...state, searchKeyword: action.payload };
    case SELECT_MOCK_SERVICES:
      return { ...state, selectedMockServices: action.payload };
    default:
      return state;
  }
};

export const reportConfigReducer: Reducer<ReportsConfig, ReportingViewActionTypes> = (
  state = reportConfigInitialState,
  action,
): ReportsConfig => {
  if (action.type === SET_REPORT_CONFIG) {
    if (action.payload === null) {
      return state;
    }
    const { selectedReport } = action.payload;
    const index = state.configList.findIndex(config => config.selectedReport.id === selectedReport.id);
    const cloneDeep = _.cloneDeep(state.configList);
    if (index === -1) {
      cloneDeep.push(action.payload);
    } else {
      cloneDeep[index] = action.payload;
    }
    return { ...state, configList: cloneDeep };
  } else {
    return state;
  }
};
